import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Card, Modal } from 'react-bootstrap';
import Select from 'react-select';
import './userform.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../../services/AxiosInstance';
import { FiArrowLeft } from 'react-icons/fi';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import { isBranchAdmin, isDepartmentAdmin, isSubDepartmentAdmin, getCurrentUserRole, isCorporateAdmin, ROLES } from '../../utils/roleAccess';
import { FIELD_LIMITS } from '../../utils/fieldLimits';
import { getRoleDescription, ROLE_INFO_SUMMARY, ACCESS_SCOPE_INFO, formatRoleLabel } from '../../utils/roleDescriptions';
import { flowdoRoleService } from '../../services/flowdoRoleService';
import { accessControlService } from '../../services/accessControlService';
import { formatStaffName, listReportsToOptions } from '../../services/StaffService';

const EditUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    CorporateId: '',
    UserType: "user",
    RoleId: '',
    FullName: '',
    Email: '',
    Department: '',
    ContactNumber: '',
    DataScope: 'limited',
    AddAsStaff: false,
    ReportsToStaffIds: [],
    staff_id: null,
    CountryId: '',
    selectedMobileCode: '',
    Password: '', // Add Password field, but keep it empty by default
    BranchId: '',
    DepartmentId: ''
  });
  const { id } = useParams();
  const location = useLocation();
  const { corporateUserId } = location.state || {};
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [corporateList, setCorporateList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedMobileCode, setSelectedMobileCode] = useState("");
  const [message, setMessage] = useState('');
  const [dataLoaded, setDataLoaded] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [subDepartmentList, setSubDepartmentList] = useState([]);
  const [isBranchDisabled, setIsBranchDisabled] = useState(false);
  const [isDepartmentDisabled, setIsDepartmentDisabled] = useState(false);
  const [isSubDepartmentDisabled, setIsSubDepartmentDisabled] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [selectedRoleName, setSelectedRoleName] = useState(null);
  const [staffUserList, setStaffUserList] = useState([]);
  const [originalRoleId, setOriginalRoleId] = useState('');
  const [showAccessOverwriteModal, setShowAccessOverwriteModal] = useState(false);

  // Helper function to get role hierarchy level (lower number = higher privilege)
  const getRoleHierarchyLevel = (roleName) => {
    if (!roleName) return 999;
    const normalized = roleName.toLowerCase().replace(/\s+/g, '_').trim();
    const hierarchy = {
      'corporate_admin': 1,
      'admin': 1, // Legacy admin
      'branch_admin': 2,
      'department_admin': 3,
      'sub_department_admin': 4,
      'user': 5
    };
    return hierarchy[normalized] || 999;
  };

  // Filter roles based on current user's privilege
  // Corporate admin can create other corporate admins, other roles can only create lower privilege roles
  const roleKey = (role) => (role?.legacy_role_key || role?.name || '').toLowerCase().replace(/\s+/g, '_').trim();

  const getFilteredRoles = () => {
    const activeRoles = roleList.filter((role) => role.name !== 'super_admin' && (role.status !== 'inactive' || role.id === formData.RoleId));
    if (!currentUserRole) return activeRoles;

    const currentUserLevel = getRoleHierarchyLevel(currentUserRole);
    const normalizedCurrentRole = currentUserRole.toLowerCase().replace(/\s+/g, '_').trim();
    const callerIsCorporateAdmin = normalizedCurrentRole === 'corporate_admin' || normalizedCurrentRole === 'admin';

    return activeRoles.filter((role) => {
      if (role.id === formData.RoleId) return true;
      if (role.is_system && !callerIsCorporateAdmin) return false;
      const level = getRoleHierarchyLevel(roleKey(role));
      if (level === 999) return true;
      if (callerIsCorporateAdmin) return true;
      return level > currentUserLevel;
    });
  };

  // Get role name from roleId
  const getRoleNameById = (roleId) => {
    const role = roleList.find(r => r.id === roleId);
    return role ? role.name : null;
  };

  // Check if field is required based on selected role
  const isBranchRequired = () => {
    if (!selectedRoleName) return false;
    const normalized = selectedRoleName.toLowerCase().replace(/\s+/g, '_').trim();
    return normalized === 'branch_admin' || normalized === 'department_admin' || normalized === 'sub_department_admin';
  };

  const isDepartmentRequired = () => {
    if (!selectedRoleName) return false;
    const normalized = selectedRoleName.toLowerCase().replace(/\s+/g, '_').trim();
    return normalized === 'department_admin' || normalized === 'sub_department_admin';
  };

  const isSubDepartmentRequired = () => {
    if (!selectedRoleName) return false;
    const normalized = selectedRoleName.toLowerCase().replace(/\s+/g, '_').trim();
    return normalized === 'sub_department_admin';
  };
  const notifyTopRight = (data) => {
    toast.success(`✔️ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyError = (data) => {

    toast.error(`❌ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch countries first
        const countryRes = await axiosInstance.get(`/auth/countrylist`);
        const countryData = countryRes.data;
        setCountries(countryData);

        // Fetch user details after countries are loaded
        const userRes = await axiosInstance.get(`/auth/details/${corporateUserId}`);
        const data = userRes.data;

        const corporateCountry = data.Corporate.country || '';
       
        
        // Extract country code from phone number if it exists
        let phoneNumber = data.phone || '';
        let countryCode = '';
        let extractedPhone = phoneNumber;
        let selectedCountryId = '';
        
      
        
        if (phoneNumber && phoneNumber.startsWith('+')) {
          // Find matching country code from countryData
          const matchedCountry = countryData.find(country =>
            phoneNumber.startsWith(country.phone_code) 
          );
     
          if (matchedCountry) {
            const phoneCode = matchedCountry.phone_code || matchedCountry.CountryCode || matchedCountry.code;
            countryCode = phoneCode; 
            extractedPhone = phoneNumber.replace(phoneCode, '').trim();
            selectedCountryId = matchedCountry.id || matchedCountry.ID;
          }
        } else {
          const matchedCountry = countryData.find(country =>
            country.name === corporateCountry
          );
          if (matchedCountry) {
            const phoneCode = matchedCountry.phone_code || matchedCountry.CountryCode || matchedCountry.code;
            countryCode = phoneCode; 
            selectedCountryId = matchedCountry.id || matchedCountry.ID;
          }
        }
        
        const updatedData = {
          CorporateUserId: data.id,
          FullName: data.full_name,
          Email: data.User.email,
          ContactNumber: extractedPhone,
          DataScope: data.data_scope || 'limited',
          AddAsStaff: !!data.staff_id,
          staff_id: data.staff_id || null,
          ReportsToStaffIds: (data.ReportsToStaff || data.reportsToStaff || []).map((staff) => staff.id),
          CountryId: selectedCountryId,
          selectedMobileCode: countryCode,
          RoleId: data.role_id,
          BranchId: data?.Branch?.id || '',
          DepartmentId: data?.Department?.id || '',
          SubDepartmentId: data?.SubDepartment?.id || ''
        };
        setFormData(updatedData);
        setOriginalRoleId(updatedData.RoleId ?? '');
        setSelectedMobileCode(countryCode);
        
        // Initialize selectedRoleName if roleId exists
        if (updatedData.RoleId) {
          // Will be set once roleList is loaded
        }
        
        // If user has a branch, fetch departments for that specific branch
        if (data?.Branch?.id) {
          try {
            const userData = JSON.parse(localStorage.getItem('user'));
            const corporateId = userData?.corporateId || userData?.id;
            const deptRes = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}&branch_id=${data.Branch.id}`);
            const deptData = deptRes.data;
            setDepartmentList(deptData.data || deptData || []);
          } catch (err) {
            console.error('Department fetch error for branch:', err);
            // Fallback to all departments if branch-specific fetch fails
            const userData = JSON.parse(localStorage.getItem('user'));
            const corporateId = userData?.corporateId || userData?.id;
            const deptRes = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
            const deptData = deptRes.data;
            setDepartmentList(deptData.data || deptData || []);
          }
        } else {
          // If user doesn't have a branch, load all departments
          try {
            const userData = JSON.parse(localStorage.getItem('user'));
            const corporateId = userData?.corporateId || userData?.id;
            const deptRes = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
            const deptData = deptRes.data;
            setDepartmentList(deptData.data || deptData || []);
          } catch (err) {
            console.error('Department fetch error:', err);
            notifyError('Failed to fetch department list');
          }
        }
        
        setDataLoaded(true);
      } catch (err) {
        console.error('User fetch error:', err);
        notifyError('Failed to fetch user details');
      }

      try {
        // Fetch role list
        try {
          const roleRes = await flowdoRoleService.list();
          const rows = roleRes.data?.data || [];
          if (rows.length) {
            setRoleList(rows);
          } else {
            const fallback = await axiosInstance.get('/corporaterolepermission/corporateuserrolelist');
            setRoleList(fallback.data?.data || []);
          }
        } catch (roleErr) {
          const fallback = await axiosInstance.get('/corporaterolepermission/corporateuserrolelist');
          setRoleList(fallback.data?.data || []);
        }
      } catch (err) {
        console.error('Role fetch error:', err);
        notifyError('Failed to fetch role list');
      }

      try {
        // Fetch branches
        const userData = JSON.parse(localStorage.getItem('user'));
        const corporateId = userData?.corporateId || userData?.id;
        const branchRes = await axiosInstance.get(`/settings/branches?corporate_id=${corporateId}`);
        setBranchList(branchRes.data.data || branchRes.data || []);
      } catch (err) {
        console.error('Branch fetch error:', err);
        notifyError('Failed to fetch branch list');
      }

      try {
        const staffRes = await listReportsToOptions();
        setStaffUserList(staffRes.data?.data || []);
      } catch (err) {
        console.error('Staff user list error:', err);
      }

      // Note: Department list will be loaded based on user's branch in the user data loading section above
      // This ensures departments are filtered by the user's existing branch
      // After initial data load, if we have department/branch, fetch sub-departments too
      try {
        const userRes2 = await axiosInstance.get(`/auth/details/${corporateUserId}`);
        const data2 = userRes2.data;
        const depId = data2?.Department?.id;
        const brId = data2?.Branch?.id;
        if (depId) {
          await fetchSubDepartmentsForFilters(depId, brId);
        }
      } catch (err) {
        // ignore
      }

      // Initialize role-based field restrictions for current logged-in user
      try {
        const role = getCurrentUserRole();
        setCurrentUserRole(role);
        
        if (isBranchAdmin(role) || isDepartmentAdmin(role) || isSubDepartmentAdmin(role)) {
          const currentUserData = JSON.parse(localStorage.getItem('user'));
          const currentUserId = currentUserData?.id;
          
          if (currentUserId) {
            try {
              const currentUserDetailsRes = await axiosInstance.get(`/auth/details/${currentUserId}`);
              const currentUserDetails = currentUserDetailsRes.data;
              
              const currentBranchId = currentUserDetails?.Branch?.id;
              const currentDepartmentId = currentUserDetails?.Department?.id;
              const currentSubDepartmentId = currentUserDetails?.SubDepartment?.id;
              
              // Disable fields based on current user's role
              if (isSubDepartmentAdmin(role)) {
                // Sub department admin: disable branch, department, sub_department
                setIsBranchDisabled(true);
                setIsDepartmentDisabled(true);
                setIsSubDepartmentDisabled(true);
              } else if (isDepartmentAdmin(role)) {
                // Department admin: disable branch, department
                setIsBranchDisabled(true);
                setIsDepartmentDisabled(true);
              } else if (isBranchAdmin(role)) {
                // Branch admin: disable branch
                setIsBranchDisabled(true);
              }
            } catch (err) {
              console.error('Error fetching current user details for role restrictions:', err);
            }
          }
        }
      } catch (err) {
        console.error('Error initializing role-based field restrictions:', err);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Handle country selection for phone code
    if (name === "CountryId") {
      console.log('Country selection changed:', value);
      console.log('Available countries:', countries);
      
      const selected = countries.find((c) => String(c.id || c.ID) === value);
      console.log('Selected country object:', selected);
      
      if (selected) {
        const phoneCode = selected.phone_code || selected.CountryCode || selected.code || "";
        console.log('Extracted phone code:', phoneCode);
        
        setSelectedMobileCode(phoneCode);
        setFormData((prev) => ({
          ...prev,
          selectedMobileCode: phoneCode
        }));
      }
    }
  };

    const fetchDepartmentsForBranch = async (value) => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}&branch_id=${value}`);
      const data = res.data;
      if (res) {
        setDepartmentList(data.data || data || []);
      }
    } catch (err) {
      console.error('Department list error:', err);
    }
  };

  const fetchSubDepartmentsForFilters = async (departmentId, branchId) => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      const buildUrl = (base) => {
        let url = `${base}?corporate_id=${corporateId}`;
        if (departmentId) url += `&department_id=${departmentId}`;
        if (branchId) url += `&branch_id=${branchId}`;
        return url;
      };
      let res;
      try {
        res = await axiosInstance.get(buildUrl(`/settings/subDepartments`));
      } catch (e1) {
        res = await axiosInstance.get(buildUrl(`/settings/subdepartments`));
      }
      const data = res.data;
      setSubDepartmentList(data.data || data || []);
    } catch (err) {
      console.error('Sub-department list error:', err);
      setSubDepartmentList([]);
    }
  };

  useEffect(() => {
    // Fetch all sub-departments initially
    fetchSubDepartmentsForFilters(null, null);
  }, []);

  // Initialize selectedRoleName when RoleId or roleList changes
  useEffect(() => {
    if (formData.RoleId && roleList.length > 0) {
      const roleName = getRoleNameById(formData.RoleId);
      if (roleName && !selectedRoleName) {
        setSelectedRoleName(roleName);
      }
    }
  }, [formData.RoleId, roleList]);

  const handleBranchChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      BranchId: value,
      DepartmentId: '', // Reset department when branch changes
      SubDepartmentId: ''
    }));
    
    // Fetch departments for selected branch
    if (value) {
      fetchDepartmentsForBranch(value);
      setSubDepartmentList([]);
    } else {
      // If no branch selected, fetch all departments
      const fetchAllDepartments = async () => {
        try {
          const userData = JSON.parse(localStorage.getItem('user'));
          const corporateId = userData?.corporateId || userData?.id;
          const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
          const data = res.data;
          if (res) {
            setDepartmentList(data.data || data || []);
          }
        } catch (err) {
          console.error('Department list error:', err);
        }
      };
      fetchAllDepartments();
      setSubDepartmentList([]);
    }
  };

  const handleDepartmentChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      DepartmentId: value,
      SubDepartmentId: ''
    }));

    fetchSubDepartmentsForFilters(value, formData.BranchId);
  };

  const generateRandomPassword = () => {
    const length = 10;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
    let password = '';
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.FullName.trim()) newErrors.FullName = 'Full Name is required';
    else if (formData.FullName.length > FIELD_LIMITS.FULL_NAME) newErrors.FullName = `Full Name cannot exceed ${FIELD_LIMITS.FULL_NAME} characters`;
    if (!formData.Email.trim()) newErrors.Email = 'Email is required';
    else if (!emailRegex.test(formData.Email)) newErrors.Email = 'Email is invalid';


    // Contact Number is now optional, but if provided, validate format
    if (formData.ContactNumber.trim()) {
      if (!/^\d+$/.test(formData.ContactNumber)) {
        newErrors.ContactNumber = 'Contact Number must be a valid number';
      } else if (formData.ContactNumber.length < 8 || formData.ContactNumber.length > 15) {
        newErrors.ContactNumber = 'Contact Number should be between 8 to 15 digits';
      }
    }

    if (!formData.CountryId) newErrors.CountryId = 'Country is required';
    if (!formData.RoleId) newErrors.RoleId = 'Role is required';

    // Validate fields based on selected role
    if (selectedRoleName) {
      const normalizedRole = selectedRoleName.toLowerCase().replace(/\s+/g, '_').trim();
      
      // Branch admin role requires branch
      if (normalizedRole === 'branch_admin' || normalizedRole === 'department_admin' || normalizedRole === 'sub_department_admin') {
        if (!formData.BranchId) {
          newErrors.BranchId = 'Branch is required for this role';
        }
      }
      
      // Department admin role requires department
      if (normalizedRole === 'department_admin' || normalizedRole === 'sub_department_admin') {
        if (!formData.DepartmentId) {
          newErrors.DepartmentId = 'Department is required for this role';
        }
      }
      
      // Sub department admin role requires sub department
      if (normalizedRole === 'sub_department_admin') {
        if (!formData.SubDepartmentId) {
          newErrors.SubDepartmentId = 'Sub Department is required for this role';
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const buildUpdatePayload = () => {
    const { DepartmentName, ...object } = formData;
    const selectedCountry = countries.find(
      (c) => String(c.id || c.ID) == formData.CountryId
    );
    const payload = {
      ...object,
      UpdatedBy: formData.CorporateId,
      CountryId: formData.CountryId,
      CountryName: selectedCountry?.name || selectedCountry?.CountryName || "",
      ContactNumber: formData.ContactNumber ? `${selectedMobileCode}${formData.ContactNumber}` : '',
      RoleId: formData.RoleId,
      BranchId: formData.BranchId || null,
      DepartmentId: formData.DepartmentId || null,
      SubDepartmentId: formData.SubDepartmentId || null,
      DataScope: formData.DataScope || 'limited',
      AddAsStaff: !!formData.AddAsStaff,
      ReportsToStaffIds: Array.isArray(formData.ReportsToStaffIds) ? formData.ReportsToStaffIds : [],
    };
    delete payload.EmployeeNumber;
    if (!formData.Password) {
      delete payload.Password;
    }
    return payload;
  };

  const saveUser = async ({ clearAccess }) => {
    const res = await axiosInstance.put(`/auth/corporateuser/update`, JSON.stringify(buildUpdatePayload()));
    if (!res) {
      notifyError('Failed to update user');
      return false;
    }
    if (clearAccess && formData.CorporateUserId) {
      await accessControlService.saveUserAccess(formData.CorporateUserId, { sections: [] });
    }
    notifyTopRight(clearAccess
      ? 'User updated. Personal access control was cleared.'
      : 'Corporate user updated successfully!');
    setOriginalRoleId(formData.RoleId ?? '');
    setTimeout(() => {
      setIsSubmitting(false);
      navigate('/settings/userlist');
    }, 2000);
    return true;
  };

  const handleSubmit = async (e, { confirmedOverwrite = false } = {}) => {
    e.preventDefault();
    setErrors({});

    if (!validate()) return;

    // Additional validation: Check if selected role is allowed (prevent same/higher privilege)
    // Skip this validation for corporate admin
    const normalizedCurrentRole = currentUserRole ? currentUserRole.toLowerCase().replace(/\s+/g, '_').trim() : '';
    if (formData.RoleId && currentUserRole && normalizedCurrentRole !== 'corporate_admin' && normalizedCurrentRole !== 'admin') {
      const selectedRole = getRoleNameById(formData.RoleId);
      if (selectedRole) {
        const selectedRoleLevel = getRoleHierarchyLevel(selectedRole);
        const currentUserLevel = getRoleHierarchyLevel(currentUserRole);
        
        if (selectedRoleLevel <= currentUserLevel) {
          notifyError('You cannot update a user to have the same or higher privilege level than yours.');
          setErrors({ RoleId: 'You cannot update a user to have the same or higher privilege level.' });
          return;
        }
      }
    }

    setLoading(true);
    setIsSubmitting(true);

    let holdSubmit = false;
    try {
      const roleChanged = String(formData.RoleId ?? '') !== String(originalRoleId ?? '');
      if (roleChanged && !confirmedOverwrite && formData.CorporateUserId) {
        const accessRes = await accessControlService.getUserAccess(formData.CorporateUserId);
        const access = accessRes?.data?.data || {};
        const hasPersonalAccess = access.source === 'user_override' && (access.sections || []).length > 0;
        if (hasPersonalAccess) {
          setShowAccessOverwriteModal(true);
          return;
        }
      }

      const saved = await saveUser({ clearAccess: confirmedOverwrite && roleChanged });
      if (saved) {
        holdSubmit = true;
        setShowAccessOverwriteModal(false);
      }
    } catch (err) {
      console.error('Submit error:', err);
      notifyError(err.response?.data?.message || err.response?.data?.error || 'Failed to update user');
    } finally {
      setLoading(false);
      if (!holdSubmit) setIsSubmitting(false);
    }
  };

  return (
    <div>
      <button
        className="back-button"
        onClick={() => {
          if (window.history.length > 2) {
            navigate(-1);
          } else {
            navigate('/settings/userlist');
          }
        }}
      >
        <FiArrowLeft style={{ marginRight: '0.5rem' }} />
        Back
      </button>
      <div className="row" style={{marginBottom: '0px !important'}}>
        <ToastContainer />
        <div className="col-xl-12 col-xxl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Edit User</h4>
            </div>
          <div className="card-body">
            {!dataLoaded ? (
              <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading user data...</p>
              </div>
            ) : (
              <section>
                <form autoComplete="off" onSubmit={(e) => { e.preventDefault(); handleSubmit(e); }}>
                <div className="row">
                  <div className="col-lg-6 mb-2">
                    <div className="form-group mb-3">
                      <label className="text-label">Full Name*</label>
                      <input
                        type="text"
                        name="FullName"
                        className="form-control"
                        placeholder="Full Name"
                        required
                        maxLength={FIELD_LIMITS.FULL_NAME}
                        value={formData.FullName}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {errors.FullName && <div className="text-danger">{errors.FullName}</div>}
                    </div>
                  </div>
                  <div className="col-lg-6 mb-2">
                    <div className="form-group mb-3">
                      <label className="text-label">Email Address*</label>
                      <input
                        type="email"
                        name='Email'
                        className="form-control"
                        id="inputGroupPrepend2"
                        aria-describedby="inputGroupPrepend2"
                        placeholder="example@example.com"
                        value={formData.Email}
                        onChange={handleChange}
                        required
                        disabled
                        autoComplete="off"
                      />
                      {errors.Email && <div className="text-danger">{errors.Email}</div>}
                    </div>
                  </div>
                  <div className="col-lg-6 mb-2">
                    <div className="form-group mb-3">
                      <label className="user-form-label text-label">Contact Number</label>
                      <div className="input-group">
                        <div className="position-relative" style={{ width: '57px' }}>
                          <span
                            className="phonecode"
                            style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', paddingLeft: '0.75rem', pointerEvents: 'none' }}
                          >
                            {selectedMobileCode || 'Code'}
                          </span>
                          <select
                            name="CountryId"
                            className="form-select phonecode"
                            value={String(formData.CountryId || '')}
                            onChange={handleChange}
                            title="Select country code"
                            style={{ position: 'absolute', inset: 0, opacity: 0, zIndex: 2 }}
                            autoComplete="off"
                          >
                            <option value="">Code</option>
                            {countries.map((country) => (
                              <option key={country.id || country.ID} value={String(country.id || country.ID)}>
                                {(country.phone_code || country.CountryCode || country.code || '') + ' ' + (country.name || '')}
                              </option>
                            ))}
                          </select>
                        </div>
                        <input
                          type="text"
                          inputMode="numeric"
                          name="ContactNumber"
                          className="form-control user-form-input"
                          placeholder="Phone Number"
                          onChange={handleChange}
                          value={formData.ContactNumber}
                          autoComplete="off"
                        />
                      </div>
                      {errors.ContactNumber && <div className="text-danger">{errors.ContactNumber}</div>}
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="form-group mb-3">
                      <label className="user-form-label mb-1"><strong>Branch{isBranchRequired() ? '*' : ''}</strong></label>
                      <div className="user-form-select-container">
                        <Select
                          classNamePrefix="user-form-select"
                          placeholder="Select Branch"
                          isClearable
                          isDisabled={isBranchDisabled}
                          value={branchList.find((branch) => branch.id === formData.BranchId) 
                            ? { value: formData.BranchId, label: branchList.find(b => b.id === formData.BranchId)?.name }
                            : null
                          }
                          onChange={(selectedOption) => {
                            const value = selectedOption ? selectedOption.value : '';
                            setFormData((prevData) => ({
                              ...prevData,
                              BranchId: value,
                              DepartmentId: '',
                              SubDepartmentId: ''
                            }));
                            
                            if (value) {
                              const fetchDepartmentsForBranch = async () => {
                                try {
                                  const userData = JSON.parse(localStorage.getItem('user'));
                                  const corporateId = userData?.corporateId || userData?.id;
                                  const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}&branch_id=${value}`);
                                  const data = res.data;
                                  if (res) {
                                    setDepartmentList(data.data || data || []);
                                  }
                                } catch (err) {
                                  console.error('Department list error:', err);
                                }
                              };
                              fetchDepartmentsForBranch();
                              setSubDepartmentList([]);
                            } else {
                              const fetchAllDepartments = async () => {
                                try {
                                  const userData = JSON.parse(localStorage.getItem('user'));
                                  const corporateId = userData?.corporateId || userData?.id;
                                  const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
                                  const data = res.data;
                                  if (res) {
                                    setDepartmentList(data.data || data || []);
                                  }
                                } catch (err) {
                                  console.error('Department list error:', err);
                                }
                              };
                              fetchAllDepartments();
                              setSubDepartmentList([]);
                            }
                          }}
                          options={branchList.map((branch) => ({
                            value: branch.id,
                            label: branch.name
                          }))}
                        />
                      </div>
                      {errors.BranchId && <p className='error'>{errors.BranchId}</p>}
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="form-group mb-3">
                      <label className="user-form-label mb-1"><strong>Department{isDepartmentRequired() ? '*' : ''}</strong></label>
                      <div className="user-form-select-container">
                        <Select
                          classNamePrefix="user-form-select"
                          placeholder="Select Department"
                          isClearable
                          isDisabled={isDepartmentDisabled}
                          value={departmentList.find((dept) => dept.id === formData.DepartmentId) 
                            ? { 
                                value: formData.DepartmentId, 
                                label: `${departmentList.find(d => d.id === formData.DepartmentId)?.name} ${departmentList.find(d => d.id === formData.DepartmentId)?.branch_name ? `(${departmentList.find(d => d.id === formData.DepartmentId)?.branch_name})` : ''}`
                              }
                            : null
                          }
                          onChange={(selectedOption) => {
                            const value = selectedOption ? selectedOption.value : '';
                            setFormData((prevData) => ({
                              ...prevData,
                              DepartmentId: value,
                              SubDepartmentId: ''
                            }));
                            fetchSubDepartmentsForFilters(value, formData.BranchId);
                          }}
                          options={departmentList.map((department) => ({
                            value: department.id,
                            label: `${department.name} ${department.branch_name ? `(${department.branch_name})` : ''}`
                          }))}
                        />
                      </div>
                      {errors.DepartmentId && <p className='error'>{errors.DepartmentId}</p>}
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="form-group mb-3">
                      <label className="user-form-label mb-1"><strong>Sub Department{isSubDepartmentRequired() ? '*' : ''}</strong></label>
                      <div className="user-form-select-container">
                        <Select
                          classNamePrefix="user-form-select"
                          placeholder="Select Sub Department"
                          isClearable
                          isDisabled={isSubDepartmentDisabled || !formData.DepartmentId}
                          value={subDepartmentList.find((sd) => sd.id === formData.SubDepartmentId) 
                            ? { 
                                value: formData.SubDepartmentId, 
                                label: `${subDepartmentList.find(s => s.id === formData.SubDepartmentId)?.name} ${subDepartmentList.find(s => s.id === formData.SubDepartmentId)?.department_name ? `(${subDepartmentList.find(s => s.id === formData.SubDepartmentId)?.department_name})` : ''}`
                              }
                            : null
                          }
                          onChange={(selectedOption) => {
                            setFormData((prevData) => ({
                              ...prevData,
                              SubDepartmentId: selectedOption ? selectedOption.value : ''
                            }));
                          }}
                          options={subDepartmentList.map((sd) => ({
                            value: sd.id,
                            label: `${sd.name} ${sd.department_name ? `(${sd.department_name})` : ''}`
                          }))                          }
                        />
                      </div>
                      {errors.SubDepartmentId && <p className='error'>{errors.SubDepartmentId}</p>}
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="form-group mb-3">
                      <label className="user-form-label mb-1">
                        <strong>Role*</strong>
                        <i
                          className="fas fa-info-circle ms-2 text-muted"
                          style={{ fontSize: '0.875rem', cursor: 'help' }}
                          title={selectedRoleName ? getRoleDescription(selectedRoleName) : ROLE_INFO_SUMMARY}
                          aria-label="Role permissions information"
                        />
                      </label>
                      <div className="user-form-select-container">
                        <Select
                          classNamePrefix="user-form-select"
                          placeholder="Select Role"
                          isClearable
                          value={getFilteredRoles().find((role) => role.id === formData.RoleId) 
                              ? { 
                                  value: formData.RoleId, 
                                  label: formatRoleLabel(roleList.find(r => r.id === formData.RoleId)?.name)
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const roleId = selectedOption ? selectedOption.value : '';
                            const roleName = selectedOption ? getRoleNameById(roleId) : null;
                            setFormData((prevData) => ({
                              ...prevData,
                              RoleId: roleId
                            }));
                            setSelectedRoleName(roleName);
                            // Clear errors when role changes
                            if (errors.BranchId || errors.DepartmentId || errors.SubDepartmentId) {
                              setErrors((prevErrors) => {
                                const newErrors = { ...prevErrors };
                                delete newErrors.BranchId;
                                delete newErrors.DepartmentId;
                                delete newErrors.SubDepartmentId;
                                return newErrors;
                              });
                            }
                          }}
                          options={getFilteredRoles().map((role) => ({
                            value: role.id,
                            label: formatRoleLabel(role.name)
                          }))}
                        />
                      </div>
                      {errors.RoleId && <p className='error'>{errors.RoleId}</p>}
                      <label className={`user-staff-check mt-3 ${formData.AddAsStaff ? 'is-checked' : ''}`}>
                        <input
                          className="user-form-checkbox"
                          type="checkbox"
                          checked={!!formData.AddAsStaff}
                          onChange={(e) => setFormData((prev) => ({ ...prev, AddAsStaff: e.target.checked }))}
                        />
                        <span>Add the user as Staff</span>
                      </label>
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="form-group mb-3">
                      <label className="user-form-label mb-1">
                        <strong>Access</strong>
                      </label>
                      <div className="user-scope-choices">
                        <label
                          className={`user-scope-choice ${formData.DataScope !== 'full' ? 'is-selected' : ''}`}
                        >
                          <input
                            className="user-form-radio"
                            type="radio"
                            name="DataScope"
                            checked={formData.DataScope !== 'full'}
                            onChange={() => setFormData((prev) => ({ ...prev, DataScope: 'limited' }))}
                          />
                          <span className="user-scope-choice__copy">
                            Limited Access
                            <i
                              className="fas fa-info-circle user-scope-choice__info"
                              title={ACCESS_SCOPE_INFO.limited}
                              aria-label={ACCESS_SCOPE_INFO.limited}
                            />
                          </span>
                        </label>
                        <label
                          className={`user-scope-choice ${formData.DataScope === 'full' ? 'is-selected' : ''}`}
                        >
                          <input
                            className="user-form-radio"
                            type="radio"
                            name="DataScope"
                            checked={formData.DataScope === 'full'}
                            onChange={() => setFormData((prev) => ({ ...prev, DataScope: 'full' }))}
                          />
                          <span className="user-scope-choice__copy">
                            Have Full Access
                            <i
                              className="fas fa-info-circle user-scope-choice__info"
                              title={ACCESS_SCOPE_INFO.full}
                              aria-label={ACCESS_SCOPE_INFO.full}
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="form-group mb-3">
                      <label className="user-form-label mb-1">
                        <strong>Reports to</strong>
                      </label>
                      <div className="user-form-select-container">
                        <Select
                          classNamePrefix="user-form-select"
                          placeholder="Select staff"
                          isMulti
                          isClearable
                          value={staffUserList
                            .filter((staff) => (formData.ReportsToStaffIds || []).some((id) => Number(id) === Number(staff.id)))
                            .map((staff) => ({ value: staff.id, label: formatStaffName(staff) }))
                          }
                          onChange={(selectedOptions) => {
                            setFormData((prev) => ({
                              ...prev,
                              ReportsToStaffIds: (selectedOptions || []).map((option) => option.value)
                            }));
                          }}
                          options={staffUserList
                            .filter((staff) => {
                              if (formData.staff_id && Number(staff.id) === Number(formData.staff_id)) return false;
                              if (formData.CorporateUserId && Number(staff.corporate_user_id) === Number(formData.CorporateUserId)) return false;
                              return true;
                            })
                            .map((staff) => ({
                              value: staff.id,
                              label: formatStaffName(staff)
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end toolbar toolbar-bottom p-2">
                    <button 
                      type="button"
                      className="btn btn-cancel me-2" 
                      onClick={() => {
                        if (window.history.length > 2) {
                          navigate(-1);
                        } else {
                          navigate('/settings/userlist');
                        }
                      }}
                      disabled={isSubmitting}
                      style={{ maxWidth: '100px' }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn user-form-btn sw-btn-next" disabled={isSubmitting} style={{maxWidth: '100px'}}>
                      {loading ? (
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      ) : null}
                      Submit
                    </button>
                  </div>

                </div>
                </form>
              </section>
            )}
          </div>
          </div>
        </div>
        <InternalFooter />
      </div>

      <Modal
        show={showAccessOverwriteModal}
        onHide={() => !loading && setShowAccessOverwriteModal(false)}
        centered
        dialogClassName="access-overwrite-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>User access control</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This user already has personal access control. That access overrides the role.
          Overwrite removes it so the new role applies.
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-cancel"
            onClick={() => setShowAccessOverwriteModal(false)}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn access-overwrite-confirm"
            onClick={() => {
              setShowAccessOverwriteModal(false);
              handleSubmit({ preventDefault() {} }, { confirmedOverwrite: true });
            }}
            disabled={loading}
          >
            Overwrite
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditUser;
